import React, { useEffect, useState, useRef } from 'react';
export function Philosophy() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <div ref={sectionRef} className="py-32 md:py-40 overflow-hidden" data-id="element-197">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-198">
        <div className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-199">
          <p className="text-2xl md:text-3xl font-light text-black/80 dark:text-white/80" data-id="element-200">
            trusted by over{' '}
            <span className="text-mint-600 dark:text-mint-400 font-medium" data-id="element-201">
              5,000 users
            </span>
          </p>
        </div>
      </div>
    </div>;
}